if (!customElements.get('l-product-recommendations')) {
	class LTAProductRecommendations extends HTMLElement {
		constructor() {
			super()

			this._observer = null
		}

		connectedCallback() {
			this._initObserver()
		}

		disconnectedCallback() {
			this._observer?.disconnect()
		}

		_initObserver() {
			this._observer?.disconnect()
			this._observer = new IntersectionObserver(
				(entries, observer) => {
					const entry = entries[0]
					if (!entry.isIntersecting) return
					observer.unobserve(this)
					this._loadRecommendations()
				},
				{ rootMargin: '0px 0px 400px 0px' }
			)
			this._observer.observe(this)
		}

		async _loadRecommendations() {
			try {
				const response = await fetch(this.dataset.url)
				const text = await response.text()

				const html = document.createElement('div')
				html.innerHTML = text

				const recommendations = html.querySelector('l-product-recommendations')
				const hasRecommendations = recommendations && recommendations.innerHTML.trim().length > 0

				if (hasRecommendations) {
					this.innerHTML = recommendations.innerHTML
				} else if (this.parentElement) {
					this.parentElement.classList.add('l-hidden')
				}
			} catch (e) {
				console.error(e)
			}
		}
	}

	customElements.define('l-product-recommendations', LTAProductRecommendations)
}

